import { EApplicantType, EDocumentStatus, EDocumentType } from '@if/core/types'
import { RequiredDocument } from '@src/types/RequiredDocument'

// True if at least one required document matches the given types, status and applicant.
export const hasRequiredDocuments = (
  requiredDocuments: RequiredDocument[],
  documentTypes: (number | string)[],
  applicantType: EApplicantType,
  status: EDocumentStatus,
): boolean =>
  requiredDocuments.some(
    (d) => documentTypes.includes(d.typeId) && d.status === status && d.applicantType === applicantType,
  )

export const getIncomeVerificationDocumentsTypes = [
  EDocumentType.DisabilityIncomeProof,
  EDocumentType.LastPayStubJob,
  EDocumentType.SixMonthsPersonalBankStatements,
  EDocumentType.FamilyAllocationsProof,
  EDocumentType.WorkIncidentIndemnisationProof,
  EDocumentType.MaternityPaternityIncomeProof,
  EDocumentType.OtherIncomeProof,
  EDocumentType.RetirementIncomeProof,
  EDocumentType.AssistanceProof,
  EDocumentType.EmployementInsuranceProof,
]

export const getIdentityDocumentTypes = [EDocumentType.ValidPhotoId]
